import React from 'react'
import cn from 'classnames'
import Title from './Title'
import Toolbar from './Toolbar'
import createActions from './createActions'

export default class QueryListScene extends React.Component {
  constructor(props) {
    super(props)
    this.actions = props.actions || createActions()
  }

  render() {
    const { title, children, size, className = '' } = this.props
    const hasToolbar = [].some.call(children || [], (child) => child?.type === Toolbar)

    return (
      <div
        className={cn('tnt-querylistscene', {
          [className]: className,
          'large-size': size === 'large',
          hasToolbar,
        })}
      >
        {title && <Title title={title} size={size} />}
        <div className="tnt-querylistscene-content">
          {React.Children.map(
            children,
            (child) =>
              child &&
              React.cloneElement(child, {
                qlsProps: this.props,
                actions: this.actions,
              })
          )}
        </div>
      </div>
    )
  }
}
